import Container from "Components/Container/Container";
import { useState } from "react";
import Input from "form/Inputs/Input";
import useInput from "form/Hooks/user-input";
import Textarea from "form/Inputs/Textarea";
import { useLocation } from "react-router-dom";
import BASE_URL from "Hooks/BASE_URL";

const RequestForm = () => {
  const location = useLocation();
  const { name } = location.state || {};

  const [isLoading, setIsLoading] = useState(false);
  const [submitSuccess, setSubmitSuccess] = useState(false);
  const [submitFailed, setSubmitFailed] = useState(false);
  const [formWarning, setFormWarning] = useState("");

  const {
    value: firstNameInput,
    isValid: firstNameIsValid,
    HasError: firstNameHasError,
    inputChangeHandler: firstNameChangeHandler,
    inputBlurHandler: firstNameBlurHandler,
    inputFocusHandler: firstNameFocusHandler,
    reset: firstNameClear,
  } = useInput((value) => value.trim() !== "");

  const {
    value: lastNameInput,
    isValid: lastNameIsValid,
    HasError: lastNameHasError,
    inputChangeHandler: lastNameChangeHandler,
    inputBlurHandler: lastNameBlurHandler,
    inputFocusHandler: lastNameFocusHandler,
    reset: lastNameClear,
  } = useInput((value) => value.trim() !== "");

  const {
    value: emailInput,
    isValid: emailIsValid,
    HasError: emailHasError,
    inputChangeHandler: emailChangeHandler,
    inputBlurHandler: emailBlurHandler,
    inputFocusHandler: emailFocusHandler,
    reset: emailClear,
  } = useInput((value) => value.trim() !== "");

  const {
    value: mobileInput,
    isValid: mobileIsValid,
    HasError: mobileHasError,
    inputChangeHandler: mobileChangeHandler,
    inputBlurHandler: mobileBlurHandler,
    inputFocusHandler: mobileFocusHandler,
    reset: mobileClear,
  } = useInput((value) => value.trim() !== "");

  const {
    value: addressInput,
    isValid: addressIsValid,
    HasError: addressHasError,
    inputChangeHandler: addressChangeHandler,
    inputBlurHandler: addressBlurHandler,
    inputFocusHandler: addressFocusHanlder,
    isFocus: addressIsFocus,
    reset: addressClear,
  } = useInput((value) => value.trim() !== "");

  const {
    value: companyNameInput,
    isValid: companyNameIsValid,
    HasError: companyNameHasError,
    inputChangeHandler: companyNameChangeHandler,
    inputBlurHandler: companyNameBlurHandler,
    inputFocusHandler: companyNameFocusHandler,
    reset: companyNameClear,
  } = useInput((value) => value.trim() !== "");

  const [quantity, setQuantity] = useState(1);

  const {
    value: messageInput,
    isValid: messageIsValid,
    HasError: messageHasError,
    inputChangeHandler: messageChangeHandler,
    inputBlurHandler: messageBlurHandler,
    inputFocusHandler: messageFocusHandler,
    reset: messageClear,
  } = useInput((value) => value.trim() !== "");

  const clearMessages = () => {
    firstNameClear();
    lastNameClear();
    emailClear();
    mobileClear();
    companyNameClear();
    messageClear();
    setQuantity(1);
    setFormWarning("");
    addressClear();
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (
      !firstNameIsValid ||
      !lastNameIsValid ||
      !emailIsValid ||
      !addressIsValid ||
      !messageIsValid ||
      !mobileIsValid
    ) {
      setFormWarning("Please fill in all the required fields.");
      return;
    }

    const formData = {
      fname: firstNameInput,
      lname: lastNameInput,
      email: emailInput,
      mobile: mobileInput,
      company_name: companyNameInput,
      quantity: quantity,
      delivery_address: addressInput,
      message: messageInput,
      Product_delivered: name,
    };

    try {
      setIsLoading(true);
      const response = await fetch(`${BASE_URL}send-request-form`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        setSubmitSuccess(true);
        setTimeout(() => setSubmitSuccess(false), 3000);
        setTimeout(clearMessages, 3000);
      } else {
        const errorData = await response.json();
        setSubmitFailed(true);
        console.error("Submission failed:", errorData);
      }
    } catch (error) {
      setSubmitFailed(true);
      console.error("Error during submission:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <section className="scroll-section-special py-32 lg:py-44">
      <Container className="flex flex-col justify-center h-full">
        <h2 className="bebas text-5xl lg:text-6xl xl:text-7xl text-white lg:text-center mb-10">
          Product Request
        </h2>

        {formWarning && (
          <p className="text-red-500 text-center mb-4">{formWarning}</p>
        )}
        {submitSuccess && (
          <p className="text-green-500 text-center mb-4">
            Form submitted successfully!
          </p>
        )}
        {submitFailed && (
          <p className="text-red-500 text-center mb-4">
            Failed to submit the form.
          </p>
        )}

        <form
          onSubmit={handleSubmit}
          className="w-full lg:w-3/4 lg:mx-auto mt-6"
        >
          <span className="flex items-center flex-col lg:flex-row gap-4 mb-4">
            <Input
              label="First Name"
              value={firstNameInput}
              onChange={firstNameChangeHandler}
              onBlur={firstNameBlurHandler}
              onFocus={firstNameFocusHandler}
              hasError={firstNameHasError}
            />
            <Input
              label="Last Name"
              value={lastNameInput}
              onChange={lastNameChangeHandler}
              onBlur={lastNameBlurHandler}
              onFocus={lastNameFocusHandler}
              hasError={lastNameHasError}
            />
          </span>
          <span className="flex items-center flex-col lg:flex-row gap-4 mb-4">
            <Input
              label="Email"
              value={emailInput}
              onChange={emailChangeHandler}
              onBlur={emailBlurHandler}
              onFocus={emailFocusHandler}
              hasError={emailHasError}
            />

            <Input
              label="Mobile"
              value={mobileInput}
              onChange={mobileChangeHandler}
              onBlur={mobileBlurHandler}
              onFocus={mobileFocusHandler}
              hasError={mobileHasError}
            />
          </span>
          <span className="flex items-center flex-col lg:flex-row gap-4 mb-4">
            <Input
              label="Company Name"
              value={companyNameInput}
              onChange={companyNameChangeHandler}
              onBlur={companyNameBlurHandler}
              onFocus={companyNameFocusHandler}
              hasError={companyNameHasError}
            />
            <Input
              type={"text"}
              label={"Delivery address"}
              name={"Delivery address"}
              id={"Delivery_address"}
              value={addressInput}
              onChange={(event) => {
                addressChangeHandler(event);
              }}
              onBlur={addressBlurHandler}
              onFocus={addressFocusHanlder}
              isFocus={addressIsFocus}
              hasError={addressHasError}
              errorMessage={"company name is required"}
            />{" "}
          </span>
          <span className="flex items-center flex-col lg:flex-row gap-4 mb-4">
            <Input
              label="Product Name"
              value={name}
              isDisabled={true}
              onChange={(event) => {
                companyNameChangeHandler(event);
              }}
            />

            <Input
              label="Quantity"
              type="number"
              value={quantity}
              isDisabled={false}
              onChange={(event) => setQuantity(event.target.value)}
            />
          </span>
          <Textarea
            label="Message"
            value={messageInput}
            onChange={messageChangeHandler}
            onBlur={messageBlurHandler}
            onFocus={messageFocusHandler}
            hasError={messageHasError}
          />
          <button
            type="submit"
            className="text-font bg-[#333] w-max mx-auto flex items-center justify-center mt-8 px-10 py-2 uppercase"
          >
            {isLoading ? "Submitting..." : "Submit"}
          </button>
        </form>
      </Container>
    </section>
  );
};

export default RequestForm;
